import React from "react";
import { Spinner } from "reactstrap";
import styled from "styled-components";

const LoadingWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 2000;
`;

const Wallpaper = styled.div`
  width: 100%;
  height: 100%;
  background: black;
  opacity: 0.4;
`;

/**
 *
 * @User : 이연우
 * @Date : 2023.06.10
 * @file : Components/Common/Loading.js
 * @Desc : 로딩, 스피너
 */
const Loading = () => {
  return (
    <LoadingWrapper >
      <Wallpaper />
      <Spinner 
        color="light" 
        className="position-absolute" 
        style={{width: '100px', height: '100px', borderWidth: '10px'}} /> 
    </LoadingWrapper>
  );
};

export default Loading
